import * as navigation from './navigation';
import * as document from './document';
import * as clientSearch from './clientSearch';
import * as podcast from './podcast';
import * as dismissible from './dismissible';
import * as aiChat from './aiChat';
import * as apiClients from './apiClients';

export const actions = {
  navigation: navigation.actions,
  document: document.actions,
  clientSearch: clientSearch.actions,
  podcast: podcast.actions,
  dismissible: dismissible.actions,
  aiChat: aiChat.actions,
  apiClients: apiClients.actions,
};
